import React from 'react';

function Project({ project }) {
  return (
    <div className="col-lg-6 col-md-6 text-center">
      <div className="single-item">
        <div className="pp-card-body">
          <div className="pp-card-top">
            <a href={project.poolUrl}>
              <div className="icon-box">
                <span>
                  <img srcset={`${project.imgUrl} 1x`} alt="#" />
                </span>
              </div>
            </a>
            <div className="title-box">
              <h3 className="d-flex align-items-center">
                <a href={project.poolUrl}>
                  <div>{project.name}</div>
                </a>
              </h3>
              <div className="item-social">
                {project.website && (
                  <a href={project.website} target="_blank">
                    <i className="fas fa-globe" />
                  </a>
                )}
                {project.twitter && (
                  <a href={project.twitter} target="_blank">
                    <i className="fab fa-twitter" />
                  </a>
                )}
                {project.blog && (
                  <a href={project.blog} target="_blank">
                    <i className="fab fa-medium-m" />
                  </a>
                )}
                {project.telegram && (
                  <a href={project.telegram} target="_blank">
                    <i className="fab fa-telegram" />
                  </a>
                )}
              </div>
              <a className="items-morex" href={project.poolUrl}>
                {/* <span className="pp-status-opening">
                  <i className="mdi mdi-circle" /> Opens in TBA
                  <b />
                </span> */}
                <div>
                  <span className>BUSD</span>
                </div>
              </a>
            </div>
          </div>
          <div className="item-desc mb-1">
            {project.description && (
              <div className="item-short-desc">{project.description}</div>
            )}
            <div className="item-learn-more" />
          </div>
          <a href={project.poolUrl}>
            <div className="part-prize">
              <div className="pp-card-info">
                <div className="pp-card-col">
                  Swap rate
                  <br />
                  <b className="nowrap">{project.price || 'TBA'}</b>
                </div>
                <div className="pp-card-col text-center ps-28">
                  Cap
                  <br />
                  <b>{project.allocation || 'TBA'}</b>
                </div>
                <div className="pp-card-col text-end">
                  Access
                  <br />
                  <b>Private</b>
                </div>
              </div>
              <div className="pp-card-info d-block">
                <div className="pp-card-progress-wrap">
                  {/* <div className="mb-2 d-flex justify-content-between align-items-center pp-card-progress-top">
                    <div className="pp-card-col">Progress</div>
                  </div> */}
                  {/* <div className="pp-card-progress">
                    <div
                      className="pp-card-progress-percent"
                      style={{ width: '0%' }}
                    />
                    <div className="pp-card-progress-label">
                      <span>
                        <b>0.00%</b>
                      </span>
                      <span className="text-allocation">
                        <b>0.0000/TBA</b>
                      </span>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Project;
